import { PendingChanges } from "./utils";
import React, { Dispatch } from "react";
import { FILTER_CONFIGS, FilterValues } from "../filterOptions";

export const createHandlers = (
    setSearchQuery: (query: string) => void,
    setIsSearching: (value: boolean) => void,
    setDisplayCount: Dispatch<React.SetStateAction<number>>,
    setPendingChanges: React.Dispatch<React.SetStateAction<PendingChanges>>,
    setAllComps: React.Dispatch<React.SetStateAction<any[]>>,
    setShowAddedOnly: (value: boolean) => void,
    setFilterValues: React.Dispatch<React.SetStateAction<FilterValues>>
) => ({
    handleSearch: (query: string) => {
        setSearchQuery(query);
    },

    handleSearchSubmit: () => {
        setIsSearching(true);
        setDisplayCount(9);
        setTimeout(() => {
            setIsSearching(false);
        }, 500);
    },

    handleAdd: (recordId: string) => {
        setPendingChanges(prev => {
            const newRemoved = new Set(prev.removed);
            newRemoved.delete(recordId);
            const newAdded = new Set(prev.added);
            newAdded.add(recordId);

            return { added: newAdded, removed: newRemoved };
        });

        setAllComps(prevComps =>
            prevComps.map(comp =>
                comp.recordId === recordId ? { ...comp, uiEnabled: true, enable: true } : comp
            )
        );
    },

    handleRemove: (recordId: string) => {
        setPendingChanges(prev => {
            const newAdded = new Set(prev.added);
            newAdded.delete(recordId);
            const newRemoved = new Set(prev.removed);
            newRemoved.add(recordId);

            return { added: newAdded, removed: newRemoved };
        });

        setAllComps(prevComps =>
            prevComps.map(comp =>
                comp.recordId === recordId ? { ...comp, uiEnabled: false, enable: false } : comp
            )
        );
    },

    handleToggleChange: (checked: boolean) => {
        setShowAddedOnly(checked);
        setDisplayCount(9);

        if (checked) {
            const resetFilters = FILTER_CONFIGS.reduce(
                (acc, config) => ({
                    ...acc,
                    [config.key]: config.key === "orderBy" ? config.defaultValue : "All",
                }),
                {}
            ) as FilterValues;

            setFilterValues(resetFilters);
        } else {
            const defaultFilters = FILTER_CONFIGS.reduce(
                (acc, config) => ({
                    ...acc,
                    [config.key]: config.defaultValue,
                }),
                {}
            ) as FilterValues;

            setFilterValues(defaultFilters);
        }
    },

    handleLoadMore: () => {
        setDisplayCount((prevCount: number) => prevCount + 9);
    },

    handleFilterChange: (filterKey: string) => (value: string) => {
        setFilterValues(prev => ({
            ...prev,
            [filterKey]: value,
        }));
    },
});
